ReactContentQuery.ExternalScripts.loadSwiperCalendar = {
    onPostRender: function (wpContext, handlebarsContext) {
        if ($(wpContext.domElement).find('.swiper-slide').length > 2) {
            var swOptionsAgenda = {
                autoplay: false,
                loop: false,
                slidesPerColumn: 2,
                slidesPerColumnFill: 'column',
                slidesPerGroup: 2,
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                }
            };
            let swiper = new Swiper('#agendaListado.swiper-container', swOptionsAgenda);
        }
    }
}